import { EventEmitter } from '@angular/core';
import { environment } from '@env/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class CommentService {
    constructor(http) {
        this.http = http;
    }
    getCountMessage(projectId) {
        CommentService.projectOpened.emit(projectId);
    }
    get(projectId, apiRoute) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/comments?api_route=${apiRoute}`);
    }
    getByProject(projectId) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/comments/comments_menu`);
    }
    store(form) {
        return this.http.post(`${environment.base_url}/comments`, form);
    }
    update(commentId, form) {
        return this.http.put(`${environment.base_url}/comments/${commentId}`, form);
    }
    delete(commentId) {
        return this.http.delete(`${environment.base_url}/comments/${commentId}`);
    }
    count(projectId) {
        return this.http.get(`${environment.base_url}/projects/${projectId}/comments/count`);
    }
    solve(commentId) {
        return this.http.get(`${environment.base_url}/comments/${commentId}/solve`);
    }
}
CommentService.projectOpened = new EventEmitter();
CommentService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CommentService_Factory() { return new CommentService(i0.ɵɵinject(i1.HttpClient)); }, token: CommentService, providedIn: "root" });
